export default __webpack_public_path__ + "static/media/mohanlal_video.f097f285.mp4";